module.exports = __webpack_public_path__ + "static/media/athena_shop.1246c0a6.jpg";